var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBuilding = function SvgBuilding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "building_svg__Isolation_Mode",
    "data-name": "Isolation Mode",
    viewBox: "0 0 781 360"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".building_svg__cls-1{fill:#c0b26a}.building_svg__cls-2{fill:#e0e0e0}.building_svg__cls-3{fill:#efefef}.building_svg__cls-5{fill:#dadada}.building_svg__cls-6{fill:#cfcfcf}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M600.18 116.65h25.41v149.1h-25.41z",
    className: "building_svg__cls-5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M574.77 116.65h25.4v149.1h-25.4z",
    style: {
      fill: "#c4c2c2"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M584.39 15.8c0 8.73 7.07 15.81 15.78 15.81s15.77-7.08 15.77-15.81S608.89 0 600.17 0s-15.78 7.08-15.78 15.8",
    className: "building_svg__cls-5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M645.64 25.17 637.3 63.3h-37.13V25.17z",
    className: "building_svg__cls-2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m554.71 25.17 8.36 38.13h37.1V25.17z",
    className: "building_svg__cls-6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M548.67 15.8h51.98v9.42h-51.98z",
    className: "building_svg__cls-1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M600.64 15.8h51.04v9.42h-51.04z",
    className: "building_svg__cls-1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m656.68 74.93-10.38 47.38h-46.13V74.93z",
    className: "building_svg__cls-2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m543.67 74.93 10.38 47.38h46.12V74.93z",
    className: "building_svg__cls-6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M536.18 63.3h64.58v11.71h-64.58z",
    className: "building_svg__cls-1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M600.75 63.3h63.42v11.71h-63.42z",
    className: "building_svg__cls-1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M486.99 278.75h283.02V360H486.99z",
    className: "building_svg__cls-2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 278.75h283.01V360H0zM283.01 278.75h203.98V360H283.01z",
    className: "building_svg__cls-1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M668.79 283.41h36.99V360h-36.99zM552.18 283.41h36.99V360h-36.99z",
    className: "building_svg__cls-6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M564.92 319.38h128.13v6.41H564.92z",
    className: "building_svg__cls-1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M668.79 325.79h12.84V360h-12.84zM576.33 325.79h12.84V360h-12.84z",
    className: "building_svg__cls-5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M.02 265.77H781v14.26H.02zM524.8 333.17h11.38V360H524.8zM503.46 333.17h11.38V360h-11.38zM503.46 301.1h32.72v32.06h-32.72z",
    className: "building_svg__cls-1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M507.61 305.57h24.41v4.68h-24.41zM486.99 280.01h283.02v8.26H486.99zM0 280.01h283.01v8.26H0zM626.25 84.59h14.02v14.03h-14.02zM604.19 84.59h14.02v14.03h-14.02zM582.14 84.59h14.02v14.03h-14.02zM560.07 84.59h14.02v14.03h-14.02z",
    className: "building_svg__cls-3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M283.01 280.01h203.98v17.66H283.01z",
    className: "building_svg__cls-1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M589.17 325.79h79.62V360h-79.62z",
    className: "building_svg__cls-3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M589.17 325.79h79.62v9.1h-79.62zM503.46 296.41h32.72v4.7h-32.72z",
    className: "building_svg__cls-1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M508.65 314.07h22.21V360h-22.21z",
    className: "building_svg__cls-2"
  })));
};
export default SvgBuilding;